// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"aw","firstSessionModal_header":"bw","firstSessionModal_title":"cw","firstSessionModal_header_tex":"ew","firstSessionModal_video":"fw","firstSessionModal_videoContent":"gw","firstSessionModal_FAQ":"hw","firstSessionModal_FAQMargin":"iw","firstSessionModal_FAQTitle":"jw","firstSessionModal_buttonContainer":"kw","firstSessionModal_buttonText":"lw","firstSessionModal_SMSBtn_mob":"mw"};
    if(module.hot) {
      // 1726593103480
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  